/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AgentContextQuery } from '@atlassian/agent-context/entrypoint/AgentContextQuery.graphql';
import parameters from '@atlassian/agent-context/entrypoint/AgentContextQuery$parameters';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';

type KnowledgePageEntryPointComponent = EntryPointComponent<
	{ agentContextQuery: AgentContextQuery },
	{},
	{},
	{}
>;

export const KnowledgePageEntryPoint: EntryPoint<
	KnowledgePageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<KnowledgePageEntryPointComponent>(
		/* webpackChunkName: "async-knowledge-page-app" */ './KnowledgePageApp.tsx',
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey ?? '';

		return {
			queries: {
				agentContextQuery: {
					options: { fetchPolicy: 'network-only' as const },
					parameters,
					variables: {
						cloudId,
						input: {
							projectByKey: { cloudId, projectKey },
						},
						first: 50,
						after: null,
						filter: null,
					},
				},
			},
		};
	},
});
